import React from "react";
import { useTranslation, initReactI18next } from "react-i18next";
import i18n from "i18next";
import translationEN from "../../constants/locales/en/translation.json";
import translationID from "../../constants/locales/id/translation.json";

const resources = {
  en: {
    translation: translationEN,
  },
  id: {
    translation: translationID,
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: localStorage.getItem('lang') || 'en',
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
});

export const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer data-testid= 'footer'>
      <div 
        className="flex flex-col sm:flex-row justify-center items-center bg-gray-100 font-lato text-center text-black p-4 bottom-0 left-0 right-0 z-1"
        data-testid="footer-copywriting"
      >
      {t("footer")}
      </div>
    </footer>
  );
};
